import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import MobileCallBar from "@/components/site/MobileCallBar";
import ChatWidget from "@/components/site/ChatWidget";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-black text-slate-100 pb-[72px] lg:pb-0">
      <Nav />
      <main>{children}</main>
      <Footer />
      <MobileCallBar />
      <ChatWidget />
    </div>
  );
}
